import { render, staticRenderFns } from "./ToolPageData.vue?vue&type=template&id=354fe18b&scoped=true&"
import script from "./ToolPageData.vue?vue&type=script&lang=ts&"
export * from "./ToolPageData.vue?vue&type=script&lang=ts&"
import style0 from "./ToolPageData.vue?vue&type=style&index=0&id=354fe18b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354fe18b",
  null
  
)

export default component.exports